import axios from "../../lib/axiosInstance";

export function fetchCompanyBranches(payload = {}) {
    const params = new URLSearchParams();
  if (payload?.page) params.append("page", payload?.page);
  if (payload?.limit) params.append("limit", payload?.limit);
  if (payload?.search) params.append("search", payload?.search);

  return axios.get(`branches?${params.toString()}`).then((res) => res.data);
}

export function updateBranch(payload) {
  const { id, ...rest } = payload;
  return axios.patch(`branches/${id}`, rest).then((res) => res.data);
}

export function createCompanyBranch(payload) {
  return axios.post(`branches`, payload).then((res) => res.data);
}

export function deleteBranch(id) {
  return axios.delete(`branches/${id}`).then((res) => res.data);
}
